module.exports = __webpack_public_path__ + "img/weixin_gongyingshang.e4e8b64a.png";